import styled from 'styled-components'
import { rainbowBackgroundGradient } from '../../../../../components/StyledComponents';

export const Backdrop = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
`

export const Content = styled('div')`
  border-radius: 6px;
  ${rainbowBackgroundGradient};
  color: ${({ theme }) => theme.colors.White};
  padding: 0px 25px;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`



export const H2 = styled('h2')`
margin: 0px;
  font-size: 26px;
  line-height: 30px;
  font-weight: 600;
  text-align: center;
`

export const H3 = styled('h3')`
margin: 0px;
  font-size: 18px;
  line-height: 18px;
  font-weight: 400;
  text-align: center;
`

export const H4 = styled.h4`
margin: 0px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  text-align: center;
`

export const InfoBox = styled.div`
  font-size: 18px;
  font-weight: 500;
  padding: 16px;
  border-radius: 8px;
  color: #ffffff;
  text-align: center;

  strong {
    font-weight: 700;
    color: #ffffff;
  }
`

export const Hello = styled('div')`
  font-size: 14px;
  font-weight: normal;
`

export const BlockedBadge = styled.div`
background-color: white;
display: flex;
align-items: center;
justify-content: center;
gap: 4px;
color: black;
  height: 32px;
  border-radius: 12px;
  padding: 0px 8px;
`